import { getRenderGraph } from '../utils/getRenderGraph'
import Page from '../components/Page/Page'
import { initializeApollo } from '../lib/apolloClient'
import { gql } from '@apollo/client'

const Index = (renderGraph: any) => {
  return <Page renderGraph={renderGraph} />
}

export default Index

const ALL_PAGE_PATHS_QUERY = gql`
  query {
    allPagePaths {
      url
      seoUrl
    }
  }
`
let cachedPagePaths: { url: string; seoUrl: string }[] | null = null

async function fetchAllPagePaths() {
  if (cachedPagePaths) {
    return cachedPagePaths
  }
  const apolloClient = initializeApollo()
  try {
    const { data } = await apolloClient.query({
      query: ALL_PAGE_PATHS_QUERY,
    })
    cachedPagePaths = data.allPagePaths
    return cachedPagePaths
  } catch (e) {
    console.error('Error fetching all page paths', JSON.stringify(e, null, 2))
    cachedPagePaths = []
    return []
  }
}

export const getStaticProps = async ({ params }) => {
  const seoPath = `/${params.all.join('/')}`
  let actualUrl = seoPath // fallback to seoPath

  try {
    const allPagePaths = await fetchAllPagePaths()

    const matched = allPagePaths.find((path) => path.seoUrl === seoPath)

    if (matched?.url) {
      actualUrl = matched.url
    }
  } catch (e) {
    console.error('Error fetching URL for seoPath', JSON.stringify(e, null, 2))
  }

  return await getRenderGraph(actualUrl)
}

export async function getStaticPaths() {
  let paths = null

  try {
    const allPagePaths = await fetchAllPagePaths()
    paths = allPagePaths.map((path) => {
      if (path.seoUrl != null && path.seoUrl != undefined && path.seoUrl != '') {
        return path.seoUrl
      } else return path.url
    })
  } catch (e) {
    console.error('Error retrieving allPagePaths', JSON.stringify(e, null, '  '))
  }
  return { paths, fallback: false }
}
